import { calculatePercentage } from '../../common';
import { ProjectsReportRecord } from '../../types';
import { WidgetState } from '../state';
import { WidgetStateError } from './use-widget-data';

export const getPhaseCompletedOnTime = (
  records: ProjectsReportRecord[],
): WidgetState<number, WidgetStateError> => {
  const totalPhases = records.reduce(
    (total, { phasesSummary: { count } = { count: 0 } }) => total + count,
    0,
  );

  if (totalPhases === 0) {
    return WidgetState.noData();
  }

  const phasesCompletedOnTime = records.reduce(
    (
      total,
      { phasesSummary: { completedOnTimeCount } = { completedOnTimeCount: 0 } },
    ) => total + completedOnTimeCount,
    0,
  );
  const phaseCompletedOnTimePercentage = calculatePercentage(
    phasesCompletedOnTime,
    totalPhases,
  );

  return WidgetState.data(phaseCompletedOnTimePercentage);
};
